import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "s20" }
const _hoisted_3 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_4 = { class: "widget shadow-100 s20 pb-2" }
const _hoisted_5 = { class: "container-full-2 s20 my-5" }
const _hoisted_6 = { class: "s13 flex justify-content-right" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "form-field-floating default sm s8_mobile ml-3" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "form-field-floating default sm s4_mobile ml-3" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "custom-filter-set-area" }
const _hoisted_15 = { class: "grid-filter6 mt-4 mb-0" }
const _hoisted_16 = { class: "form-field-floating reactive sm" }
const _hoisted_17 = { class: "form-field-floating reactive sm" }
const _hoisted_18 = { class: "form-field-floating reactive sm" }
const _hoisted_19 = { class: "form-field-floating sm" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "form-field-floating sm" }
const _hoisted_22 = { class: "table separator skin3 selection rounded" }
const _hoisted_23 = {
  class: "btn-circle",
  for: "check-list1"
}
const _hoisted_24 = ["checked"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "selection-item" }
const _hoisted_27 = ["for"]
const _hoisted_28 = ["id", "value"]
const _hoisted_29 = { class: "flex align-items-center bg-white h-100p" }
const _hoisted_30 = {
  class: "square-xl rounded-15",
  style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
}
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 0,
  class: "square-xl rounded-15 ml-3 px-3 py-3",
  style: {"background-color":"rgb(var(--color-black-rgb), 0.08)"}
}
const _hoisted_33 = { style: {"width":"20%"} }
const _hoisted_34 = { class: "text-xl font-semibold mb-2" }
const _hoisted_35 = {
  key: 0,
  class: "tag-state warning stroke"
}
const _hoisted_36 = {
  key: 1,
  class: "tag-state success stroke"
}
const _hoisted_37 = {
  key: 2,
  class: "tag-state notif stroke"
}
const _hoisted_38 = {
  key: 3,
  class: "tag-state danger stroke"
}
const _hoisted_39 = { class: "text-sm text-grey-600" }
const _hoisted_40 = { class: "text-sm text-grey-600" }
const _hoisted_41 = {
  class: "text-3xl",
  style: {"width":"10%"}
}
const _hoisted_42 = { class: "mt-1 text-sm" }
const _hoisted_43 = { class: "flex-right gap-4" }
const _hoisted_44 = { style: {"display":"flex","flex-direction":"row","justify-content":"center"} }

import { computed, inject, onMounted, reactive, ref, toRaw } from 'vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import ToastNotification from '@/components/ToastNotification.vue';
    import axios from 'axios';
    import { formatDate } from '../../utils';
    import { useRoute } from 'vue-router';
    import ImportMembresComponent from '../collectivites/collectivites/@components/ImportMembresComponent.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersListView',
  setup(__props) {

    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const refreshKey = ref(0);
    const errorMessage = ref('');
    const loading = ref(false);
    const loadingExportToExcel = ref(false);
    const loadingExportToPdf = ref(false);
    const loadingInvitations = ref(false);
    const toastMessage = ref('');
    const toastType = ref<'success' | 'error' | 'info' | 'warning'>('success');
    const showToast = ref(false);
    const itemsList = ref([] as any[]);
    const selectedItem = ref(null as any);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return itemsList.value.length == selectedItems.value.length;
    });
    const startupInfos = reactive({
        collectivites: [] as any[],
        pays: [] as any[]
    });
    const queryParams = reactive({
        pageNumber: 1,
        sortDir: 'ASC',
        sortColumn: 'fullname',
        sortOption: 'fullname_asc',
        borneInf: '',
        borneSup: '',
        pays_id: '',
        collectivite_id: '',
        search: '',
        trashed: 0
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const SORT_OPTIONS = [
        { value: 'fullname_asc', label: 'Nom & Prénoms (ASC)', sort_column: 'fullname', sort_direction: 'ASC' },
        { value: 'fullname_desc', label: 'Nom & Prénoms (DESC)', sort_column: 'fullname', sort_direction: 'DESC' },
        { value: 'created_at_asc', label: 'Date (ASC)', sort_column: 'created_at', sort_direction: 'ASC' },
        { value: 'created_at_desc', label: 'Date (DESC)', sort_column: 'created_at', sort_direction: 'DESC' },
    ]
    const showAdvancedFilters = ref(false);

    onMounted(() => {
        const startupDatas: any = route.meta.startupinfos_datas;
        Object.assign(startupInfos, startupDatas);

        // Lire la variable sort_dir dans le query params de l'URL
        const sortParam = route.query.sort as string;
        if (sortParam) { queryParams.sortOption = sortParam; onFiltersChanged(); }
        
        // Lire collectivite_id depuis les query params
        const collectiviteIdParam = route.query.collectivite_id as string;
        if (collectiviteIdParam) {
            queryParams.collectivite_id = collectiviteIdParam;
        }
        
        doListItems();
    });

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/users/list?${queryString}`);
            itemsList.value = httpResponse.data.data;
            pagination.total = httpResponse.data.total;
            pagination.per_page = httpResponse.data.per_page;
            pagination.last_page = httpResponse.data.last_page;
            selectedItems.value = [];
        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    async function doDeleteItem(item: any) {
        const confirmation = await confirmationModalRef.value?.open("Membres", "Voulez-vous vraiment supprimer l'élément sélectionné ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/users/destroy/${item.id}`);
                doListItems();
            } catch (error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    async function doRestoreItem(item: any) {
        const confirmation = await confirmationModalRef.value?.open("Membres", "Voulez-vous vraiment restaurer l'élément sélectionné ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/users/restore/${item.id}`);
                doListItems();
            } catch (error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    function doSelectItem(item: any) {
        selectedItem.value = item;
    }

    function doUnselectItem() {
        selectedItem.value = null;
    }

    async function doToggleEtatValideAction(itemsIds: any[]) {
        const confirmation = await confirmationModalRef.value?.open("Membres", "Voulez-vous vraiment modifier l'état des éléments sélectionnés ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/users/toggle_etat_valide`, { ids: itemsIds });

                itemsIds.forEach(itemId => {
                    const index = itemsList.value.findIndex(i => i.id == itemId);
                    if (index > -1) {
                        itemsList.value[index].actif = itemsList.value[index].actif == 1 ? 0 : 1;
                    }
                });

            } catch (error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    async function doExportToExcelAction() {
        try {
            loadingExportToExcel.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const response = await axios.get(`/backoffice/users/export_excel?${queryString}`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'utilisateurs.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loadingExportToExcel.value = false;
        }
    }

    async function doExportToPdfAction() {
        try {
            loadingExportToPdf.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const response = await axios.get(`/backoffice/users/export_pdf?${queryString}`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'utilisateurs.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loadingExportToPdf.value = false;
        }
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = itemsList.value.map(i => i.id);
        } else {
            selectedItems.value = [];
        }
    }

    function onFiltersChanged() {
        const sortItem = SORT_OPTIONS.find(o => o.value == queryParams.sortOption);
        if (sortItem) {
            queryParams.sortColumn = sortItem.sort_column;
            queryParams.sortDir = sortItem.sort_direction;
        }
        doListItems();
    }

    function onPaginate(pageNumber: number) {
        queryParams.pageNumber = pageNumber;
        doListItems();
    }

    function toggleAdvancedFilters() {
        showAdvancedFilters.value = !showAdvancedFilters.value;
    }

    async function downloadCsv() {
        try {
            const response = await axios.get("/backoffice/collectivites/membres/download_csv_template", { responseType: "blob" });
            const blob = new Blob([response.data], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "collectivite_membres_template.csv");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Erreur de téléchargement :", error);
        }
    }

    function onMembersImported() {
        refreshKey.value++;
        doListItems();
    }

    async function sendInvitationsUnverified() {
        if (!queryParams.collectivite_id && selectedItems.value.length === 0) return;
        
        try {
            // Récupérer le nombre de membres non vérifiés
            const countResponse = await axios.get('/backoffice/collectivites/membres/count_unverified', {
                params: { collectivite_id: queryParams.collectivite_id }
            });
            
            const unverifiedCount = countResponse.data.count || 0;
            
            if (unverifiedCount === 0) {
                toastMessage.value = "Aucun membre non vérifié trouvé pour cette collectivité";
                toastType.value = 'info';
                showToast.value = true;
                return;
            }
            
            // Afficher la modale de confirmation
            const confirmation = await confirmationModalRef.value?.open(
                "Envoyer les invitations",
                `Vous êtes sur le point d'envoyer ${unverifiedCount} invitation(s) aux membres non vérifiés de cette collectivité. Voulez-vous continuer ?`
            );
            
            if (!confirmation) {
                return;
            }
            
            loadingInvitations.value = true;
            toastMessage.value = '';
            showToast.value = false;
            
            const response = await axios.post('/backoffice/collectivites/membres/send_invitations_unverified', {
                collectivite_id: queryParams.collectivite_id
            });
            
            toastMessage.value = response.data.message || 'Invitations envoyées avec succès';
            toastType.value = 'success';
            showToast.value = true;
            
            // Rafraîchir la liste après l'envoi
            setTimeout(() => {
                doListItems();
            }, 1000);
        } catch (error: any) {
            console.error("Erreur lors de l'envoi des invitations:", error);
            toastMessage.value = error.response?.data?.message || "Une erreur est survenue lors de l'envoi des invitations";
            toastType.value = 'error';
            showToast.value = true;
        } finally {
            loadingInvitations.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      (queryParams.collectivite_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(), _createBlock(ImportMembresComponent, {
              "collectivite-id": parseInt(queryParams.collectivite_id as string),
              key: refreshKey.value,
              onCompleted: onMembersImported
            }, null, 8, ["collectivite-id"]))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "s7" }, [
            _createElementVNode("h4", { class: "font-semibold mt-4" }, [
              _createTextVNode("Membres "),
              _createElementVNode("span", { class: "text-sm text-grey-500" }, "(recent)")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            (queryParams.collectivite_id)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: downloadCsv,
                    class: "btn normal ml-3 justify-content-center btn-filtre"
                  }, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("img", {
                      src: "/icons/icon-telecharger.svg",
                      class: "btn-icon",
                      alt: ""
                    }, null, -1),
                    _createElementVNode("span", null, "Modèle CSV", -1)
                  ]))]),
                  _cache[12] || (_cache[12] = _createElementVNode("label", {
                    for: "file-upload-membres-list",
                    class: "btn normal ml-3 justify-content-center btn-filtre",
                    style: {"cursor":"pointer"}
                  }, [
                    _createElementVNode("img", {
                      src: "/icons/icon-upload.svg",
                      class: "btn-icon",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Importer CSV")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: sendInvitationsUnverified,
                    class: "btn normal ml-3 justify-content-center btn-filtre",
                    disabled: loadingInvitations.value || selectedItems.value.length == 0
                  }, [
                    _cache[11] || (_cache[11] = _createElementVNode("img", {
                      src: "/icons/icon-send.svg",
                      class: "btn-icon",
                      alt: ""
                    }, null, -1)),
                    (!loadingInvitations.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Envoyer invitations (" + _toDisplayString(selectedItems.value.length) + ")", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "Envoi..."))
                  ], 8, _hoisted_7)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("select", {
                class: "form-input-select",
                id: "filters_collectivite",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.collectivite_id) = $event)),
                onChange: onFiltersChanged
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "Toutes les collectivités", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.collectivites, (option, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option.id,
                    key: 'filter_collectivite_' + index
                  }, _toDisplayString(option.nom), 9, _hoisted_11))
                }), 128))
              ], 544), [
                [_vModelSelect, queryParams.collectivite_id]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("select", {
                class: "form-input-select",
                id: "filters_sort",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.sortOption) = $event)),
                onChange: onFiltersChanged
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SORT_OPTIONS, (option, index) => {
                  return _createElementVNode("option", {
                    value: option.value,
                    key: 'filter_sort_' + index
                  }, _toDisplayString(option.label), 9, _hoisted_13)
                }), 64))
              ], 544), [
                [_vModelSelect, queryParams.sortOption]
              ])
            ]),
            _createElementVNode("button", {
              onClick: toggleAdvancedFilters,
              class: "btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter"
            }, [...(_cache[14] || (_cache[14] = [
              _createElementVNode("img", {
                src: "/icons/icon-filter.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Options", -1)
            ]))])
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-input",
                  id: "filters_search",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.search) = $event)),
                  placeholder: "",
                  onKeyup: _withKeys(onFiltersChanged, ["enter"])
                }, null, 544), [
                  [_vModelText, queryParams.search]
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("label", { for: "filters_search" }, "Recherche", -1))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-input",
                  id: "filters_borne_inf",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.borneInf) = $event)),
                  placeholder: "",
                  onChange: onFiltersChanged
                }, null, 544), [
                  [_vModelText, queryParams.borneInf]
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("label", { for: "filters_borne_inf" }, "Date de création >=", -1))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-input",
                  id: "filters_borne_sup",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryParams.borneSup) = $event)),
                  placeholder: "",
                  onChange: onFiltersChanged
                }, null, 544), [
                  [_vModelText, queryParams.borneSup]
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("label", { for: "filters_borne_sup" }, "Date de création <=", -1))
              ]),
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-input-select",
                  id: "filters_pays",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((queryParams.pays_id) = $event)),
                  onChange: onFiltersChanged
                }, [
                  _cache[18] || (_cache[18] = _createElementVNode("option", { value: "" }, "Tous les pays", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.pays, (option, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: option.id,
                      key: 'filter_pays_' + index
                    }, _toDisplayString(option.nom), 9, _hoisted_20))
                  }), 128))
                ], 544), [
                  [_vModelSelect, queryParams.pays_id]
                ]),
                _cache[19] || (_cache[19] = _createElementVNode("label", { for: "filters_pays" }, [
                  _createTextVNode("Pays "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-input-select",
                  id: "filters_trashed",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((queryParams.trashed) = $event)),
                  onChange: onFiltersChanged
                }, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("option", { value: "0" }, "Membres valides", -1),
                  _createElementVNode("option", { value: "1" }, "Membres en sommeil", -1)
                ]))], 544), [
                  [_vModelSelect, queryParams.trashed]
                ]),
                _cache[21] || (_cache[21] = _createElementVNode("label", { for: "filters_trashed" }, [
                  _createTextVNode("Etat "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ]),
              _createVNode(_component_custom_button, {
                "classes-list": "btn black normal mx-0 btn-filtre",
                loading: loadingExportToExcel.value,
                onClick: doExportToExcelAction
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createElementVNode("img", {
                    src: "/icons/icon-excel.svg",
                    class: "btn-icon",
                    alt: ""
                  }, null, -1),
                  _createElementVNode("span", null, "Exporter Excel", -1)
                ]))]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_custom_button, {
                "classes-list": "btn black normal mx-0 btn-filtre",
                loading: loadingExportToPdf.value,
                onClick: doExportToPdfAction
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("img", {
                    src: "/icons/icon-pdf.svg",
                    class: "btn-icon",
                    alt: ""
                  }, null, -1),
                  _createElementVNode("span", null, "Exporter PDF", -1)
                ]))]),
                _: 1
              }, 8, ["loading"])
            ])
          ], 512), [
            [_vShow, showAdvancedFilters.value]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_22, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("label", _hoisted_23, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "check_all",
                    checked: areAllItemsSelected.value,
                    onChange: handleCheckAll
                  }, null, 40, _hoisted_24)
                ])
              ]),
              _cache[26] || (_cache[26] = _createElementVNode("th", null, null, -1)),
              _cache[27] || (_cache[27] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Information")
              ], -1)),
              _cache[28] || (_cache[28] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Utilisation")
              ], -1)),
              _cache[29] || (_cache[29] = _createElementVNode("th", null, "Collectivité", -1)),
              _cache[30] || (_cache[30] = _createElementVNode("th", { class: "flex-right" }, [
                _createElementVNode("button", { class: "btn-ultra color2" }, [
                  _createElementVNode("div", { class: "btn-show" }, [
                    _createElementVNode("img", {
                      src: "/icons/icon-actif.svg",
                      class: "btn-icon",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Actif")
                  ]),
                  _createElementVNode("div", { class: "btn-loading" }, [
                    _createElementVNode("div", { class: "loader-dots" })
                  ])
                ])
              ], -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (itemsList.value.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [...(_cache[31] || (_cache[31] = [
                  _createElementVNode("td", { colspan: "6" }, [
                    _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucun élément trouvé")
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "text-grey-700 over-effect",
                key: 'item_' + index
              }, [
                _createElementVNode("td", _hoisted_26, [
                  _createElementVNode("label", {
                    class: "btn-circle",
                    for: 'item_check_' + index
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      name: "selectedItems[]",
                      id: 'item_check_' + index,
                      value: item.id,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedItems).value = $event))
                    }, null, 8, _hoisted_28), [
                      [_vModelCheckbox, selectedItems.value]
                    ])
                  ], 8, _hoisted_27)
                ]),
                _createElementVNode("td", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("img", {
                      src: !!item.photo_url ? item.photo_url : '/assets/users_avatar/600w/user.jpg',
                      width: "100%"
                    }, null, 8, _hoisted_31)
                  ]),
                  (item.collectivite)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [...(_cache[32] || (_cache[32] = [
                        _createElementVNode("img", {
                          src: "/assets/logos/logo2.svg",
                          width: "100%"
                        }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_33, [
                  _createElementVNode("p", _hoisted_34, [
                    _createTextVNode(_toDisplayString(item.nom + ' ' + item.prenom) + "   ", 1),
                    (!item.email_verified_at)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, "En cours"))
                      : _createCommentVNode("", true),
                    (item.email_verified_at)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Vérifié"))
                      : _createCommentVNode("", true),
                    (item.actif == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Actif"))
                      : _createCommentVNode("", true),
                    (item.actif == 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Inactif"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", _hoisted_39, _toDisplayString(item.email), 1),
                  _createElementVNode("p", _hoisted_40, _toDisplayString(item.telephone), 1)
                ]),
                _createElementVNode("td", _hoisted_41, [
                  (item.quotite_cessible_pourcent)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(item.quotite_cessible_pourcent) + "% ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("-")
                      ], 64)),
                  _createElementVNode("p", _hoisted_42, [
                    (item.quotite_cessible_montant)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(new Intl.NumberFormat('fr-FR').format(item.quotite_cessible_montant)) + " F ", 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("-")
                        ], 64))
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(item.collectivite?.nom || 'N/A'), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_router_link, {
                      to: '/app/users/form/' + item.id
                    }, {
                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createElementVNode("button", { class: "btn tips" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-edit.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Editer")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    (item.deleted_at == null && item.actif == 1)
                      ? (_openBlock(), _createBlock(_component_custom_button, {
                          key: 0,
                          classesList: 'btn-ultra color2 tips',
                          onClick: ($event: any) => (doToggleEtatValideAction([item.id]))
                        }, {
                          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                            _createElementVNode("img", {
                              src: "/icons/icon-actif.svg",
                              class: "btn-icon",
                              alt: ""
                            }, null, -1),
                            _createElementVNode("span", null, "Actif", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (item.deleted_at == null && item.actif == 0)
                      ? (_openBlock(), _createBlock(_component_custom_button, {
                          key: 1,
                          classesList: 'btn-ultra color2 tips',
                          onClick: ($event: any) => (doToggleEtatValideAction([item.id]))
                        }, {
                          default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                            _createElementVNode("img", {
                              src: "/icons/icon-inactif.svg",
                              class: "btn-icon",
                              alt: ""
                            }, null, -1),
                            _createElementVNode("span", null, "Inactif", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      to: '/app/users/' + item.id + '/details'
                    }, {
                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Gérer")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      to: '/app/users/' + item.id + '/carte'
                    }, {
                      default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Carte")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      to: '/app/users/' + item.id + '/utilisation'
                    }, {
                      default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Utilisation")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      to: '/app/users/' + item.id + '/plan'
                    }, {
                      default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Plan")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      to: '/app/users/' + item.id + '/revolving'
                    }, {
                      default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Revolving")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_component_custom_pagination, {
            modelValue: queryParams.pageNumber,
            "onUpdate:modelValue": [
              _cache[8] || (_cache[8] = ($event: any) => ((queryParams.pageNumber) = $event)),
              onPaginate
            ],
            total: pagination.total,
            "per-page": pagination.per_page,
            last_page: pagination.last_page
          }, null, 8, ["modelValue", "total", "per-page", "last_page"])
        ])
      ]),
      _cache[41] || (_cache[41] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
    ]),
    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512),
    _createVNode(ToastNotification, {
      message: toastMessage.value,
      type: toastType.value,
      show: showToast.value,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (showToast.value = $event))
    }, null, 8, ["message", "type", "show"])
  ]))
}
}

})